import ApiClient from "./apiClient";
import { QueriesApi } from "./apiTypes";


const billingService = {
  getRemainingInfo:() => ApiClient.get('openstack/billing/credit_and_invoicing_info'),
  getSummary:() => ApiClient.get('billing/summary'),
  getOpenStackSummary:() => ApiClient.get('openstack/summary'),

  getBillingOverview:(queries:any = {}) => ApiClient.get('billing/overview', {
    params:{
      start_date: queries.start_date,
      end_date: queries.end_date,
      payment_type: queries.payment_type,
    }
  }),
  getBillingOverviewJournals:(queries:any = {}) => ApiClient.get('billing/overview/journals', {
    params:{
      start_date: queries.start_date,
      end_date: queries.end_date,
      payment_type: queries.payment_type,
    }
  }),

  getJournal:(queries:QueriesApi) => ApiClient.get('billing/journal',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
      client_id: queries.client
    }
  }),
  deleteJournalItem:(id:string) => ApiClient.delete(`billing/journal/${id}`),
  getJournalItem:(id:string) => ApiClient.get(`billing/journal/${id}`),
  editJournalItem:(id:string, data:any) => ApiClient.put(`billing/journal/${id}`, data),


  getGateways:(queries:QueriesApi) => ApiClient.get('billing/gateways',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getGatewayById:(gatewayId:string) => ApiClient.get(`billing/gateways/${gatewayId}`),
  editGatewayById:(gatewayId:string, data:any) => ApiClient.put(`billing/gateways/${gatewayId}`, data),

  getInvoiceList:(queries:QueriesApi) => ApiClient.get('billing/invoices',{
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
      client:queries.client,
    }
  }),
  getServices:(queries:QueriesApi) => ApiClient.get(`billing/services`, {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
      client:queries.client,
    }
  }),
  getProductGroups:(queries:QueriesApi) => ApiClient.get(`billing/productgroups`, {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getInvoice:(invoiceId:any) => ApiClient.get(`billing/invoices/${invoiceId}`),
  createInvoice:(data:Object) => ApiClient.post('billing/invoices', data),
  createOptions:() => ApiClient.get('billing/invoices/create_options'),
  editOptions:(invoiceId:any) => ApiClient.get(`billing/invoices/${invoiceId}/invoice_edit_options`),
  getServicesByClient:(clientId:any) => ApiClient.get(`billing/services?page_size=20&client=${clientId}`),
  getServiceCycles:(serviceId:any, queries:Partial<QueriesApi> = {}) => ApiClient.get(`billing/service-cycles`, {
    params:{
      service_id: serviceId,
      page: queries.page,
      page_size: queries.page_size || queries.pageSize || 20,
      ordering: queries.ordering || '-id',
    }
  }),
  // kept for backward compatibility with older calls
  createServiceCycles:(serviceId:any) => ApiClient.get(`billing/service-cycles?page_size=20&service_id=${serviceId}`),

  deleteInvoice:(invoiceId:string | number) => ApiClient.delete(`billing/invoices/${invoiceId}`),

  payFromCredit:(invoiceId:string) => ApiClient.post(`billing/invoices/${invoiceId}/pay_from_credit_balance`),
  getService:(serviceId:string) => ApiClient.get(`billing/services/${serviceId}`),
  getUpgradeOption:(serviceId:string) => ApiClient.get(`billing/services/${serviceId}/upgrade_options`),
  createOpenstackService:(data:any) => ApiClient.post(`openstack/billing/services/create_openstack_service`, data),
  getNewServiceData:(clientId:string|number) => ApiClient.get(`openstack/billing/services/new_service_data`, { params: { client_id: clientId } }),
  executeAction:(serviceId:string, data:Object) => ApiClient.post(`billing/services/${serviceId}/execute_action`, data),
  createNewServiceCycle:(serviceId:string|number) => ApiClient.post(`billing/services/${serviceId}/new-cycle`, {}),
  getAvailableBillingServices:(clientId:string|number) => ApiClient.get(`openstack/billing/usage/available_services`, {
    params:{
      client_id:clientId,
    }
  }),
  getBillingHistory:(queries:QueriesApi) => ApiClient.get(`openstack/billing/usage/client`,{
    params:{
      client_id:queries.client,
      service_id:queries.service_id,
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
    }
  }),
  getBillingById:(billingId:string) => ApiClient.get(`openstack/billing/usage/${billingId}`),
  getUnpaidInvoices:(currency:string) => ApiClient.get('billing/invoices',{
    params: {
      page_size:1000,
      detailed_list:true,
      filtering:`status:unpaid+currency:${currency}`,
    }
  }),
  getRemainingDate:() => ApiClient.get('openstack/billing/credit_and_invoicing_info'),
  addCreditInvoice:(data:Object) => ApiClient.post(`billing/invoices/add_credit_invoice`,data),
  editInvoice:(invoiceId:string, data:Object) => ApiClient.put(`billing/invoices/${invoiceId}`, data),
  mergeInvoices:(data:any) => ApiClient.post(`billing/invoices/merge_invoices`, data),
  executeActionAllInstances:(serviceId:string|number, data:Object) => ApiClient.post(`billing/services/${serviceId}/execute_action`, data),
  getPaymentMethods:(data?:Object) => ApiClient.get(`billing/gateway/wayforpay/cards`),
  confirmPaymentMethod:(data?:Object) => ApiClient.post(`billing/gateway/wayforpay/confirm_code`, data),
  deletePaymentMethod:(data?:Object) => ApiClient.post(`billing/gateway/wayforpay/delete_card`, data),
  getAutopayConfig:() => ApiClient.get(`billing/gateway/wayforpay/auto_pay_config`),
  updateAutopayConfig:(data:Object) => ApiClient.post(`billing/gateway/wayforpay/auto_pay_config`, data),
  changeCardStatus:(data:Object) => ApiClient.post(`billing/gateway/wayforpay/change_activate_card_status`, data),
  addCreditFromPaymentMethod:(data:Object) => ApiClient.post(`billing/gateway/wayforpay/card_pay`, data),

  getOrders:(queries:QueriesApi) => ApiClient.get('billing/orders', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  getOrder:(orderId:string|number) => ApiClient.get(`billing/orders/${orderId}`),
  deleteOrder:(orderId:string|number) => ApiClient.delete(`billing/orders/${orderId}`),
  acceptOrder:(orderId:string|number) => ApiClient.post(`billing/orders/${orderId}/accept`, {}),
  cancelOrder:(orderId:string|number) => ApiClient.post(`billing/orders/${orderId}/cancel`, {}),
  verifyOrder:(orderId:string|number) => ApiClient.post(`billing/orders/${orderId}/verify`, {}),
  setOrderPending:(orderId:string|number) => ApiClient.post(`billing/orders/${orderId}/pending`, {}),
  setOrderFraud:(orderId:string|number) => ApiClient.post(`billing/orders/${orderId}/fraud`, {}),
  runOrderFraudCheck:(orderId:string|number) => ApiClient.post(`billing/orders/${orderId}/fraud_check`, {}),

  getCart:() => ApiClient.get('billing/cart'),
  placeCartOrder:() => ApiClient.post('billing/cart/order', {}),
  startCartOrder:(data:any) => ApiClient.post('billing/cart/items/start_order', data),
  dropCart:(data:any = {}) => ApiClient.post('billing/cart/items/drop_cart', data),
  getCartItem:(cartItemId:string|number) => ApiClient.get(`billing/cart/items/${cartItemId}`),
  deleteCartItem:(cartItemId:string|number) => ApiClient.delete(`billing/cart/items/${cartItemId}`),
  updateCartItem:(cartItemId:string|number, data:any) => ApiClient.put(`billing/cart/items/${cartItemId}`, data),
  createCartItem:(data:any) => ApiClient.post('billing/cart/items', data),
  getCartItemCreateOptions:(productCode:string|number, cycle?:string|number) => {
    const params:any = { product_code: productCode };
    if (cycle) params.cycle = cycle;
    return ApiClient.get('billing/cart/items/create_options', { params });
  },
  getCartItemEditOptions:(cartItemId:string|number) => ApiClient.get(`billing/cart/items/${cartItemId}/edit_options`),


  getTaxeRules:(queries:QueriesApi) => ApiClient.get('billing/tax_rules', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getCreateOptionsTaxeRules:() => ApiClient.get('billing/taxrules/create_options', {}),


  getConfigOptions:(queries:QueriesApi) => ApiClient.get('billing/configoptions', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    }
  }),
  getCreateOptionsConfigOptions:() => ApiClient.get('billing/configoptions/create_options', {}),

  // Service editing and upgrade methods
  updateService:(serviceId:string|number, data:Object) => ApiClient.put(`billing/services/${serviceId}`, data),
  getServiceUpgradeOptions:(serviceId:string|number, cycleId?:string|number, productId?:string|number) => {
    const params: any = {};
    if (cycleId) params.cycle = cycleId;
    if (productId) params.product = productId;
    return ApiClient.get(`billing/services/${serviceId}/upgrade_options`, { params });
  },
  upgradeService:(serviceId:string|number, data:Object) => ApiClient.post(`billing/services/${serviceId}/upgrade`, data),
  getServiceNewFixedPrice:(serviceId:string|number, cycleId:string|number, overridePrice?:number, configurableOptions?:any[], isFree?:boolean) => {
    const params: any = {
      cycle: cycleId,
    };
    if (overridePrice !== undefined) params.override_price = overridePrice;
    if (configurableOptions) params.configurable_options = JSON.stringify(configurableOptions);
    if (isFree !== undefined) params.is_free = isFree;
    return ApiClient.get(`billing/services/${serviceId}/new_fixed_price`, { params });
  },
  getProducts:(queries?:QueriesApi) => ApiClient.get('billing/products', {
    params: queries ? {
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search
    } : {}
  }),
  getProduct:(productId:string|number) => ApiClient.get(`billing/products/${productId}`),
  getProductCreateOptions:() => ApiClient.get('billing/products/create_options'),
  createProduct:(data:any) => ApiClient.post('billing/products', data),
  updateProduct:(productId:string|number, data:any) => ApiClient.put(`billing/products/${productId}`, data),
  deleteProduct:(productId:string|number) => ApiClient.delete(`billing/products/${productId}`),

  createProductGroup:(data:any) => ApiClient.post('billing/productgroups', data),
  updateProductGroup:(groupId:string|number, data:any) => ApiClient.put(`billing/productgroups/${groupId}`, data),
  deleteProductGroup:(groupId:string|number) => ApiClient.delete(`billing/productgroups/${groupId}`),
  getConfigurableOptionPrice:(optionId:string|number, currency:string, cycleParams:string, optionValue:string, configurableOptions:string, serviceId?:string|number) => {
    const params: any = {
      currency,
      cycle_params: cycleParams,
      option_value: optionValue,
      configurable_options: configurableOptions,
    };
    if (serviceId) params.service_id = serviceId;
    return ApiClient.get(`billing/configurable-options/${optionId}/price`, { params });
  },

  // Service actions
  suspendService:(serviceId:string|number, flags?:Record<string, boolean>) =>
    ApiClient.post(`billing/services/${serviceId}/suspend`, { flags: flags || {} }),

  resumeService:(serviceId:string|number) =>
    ApiClient.post(`billing/services/${serviceId}/unsuspend`, {}),

  activateService:(serviceId:string|number) =>
    ApiClient.post(`billing/services/${serviceId}/activate`, {}),

  terminateService:(serviceId:string|number) =>
    ApiClient.post(`billing/services/${serviceId}/terminate`, {}),

  getOpenstackServices:(clientId:string|number) =>
    ApiClient.get(`openstack/billing/services/openstack_services`, { params: { client_id: clientId } }),

  updateBillingPlan:(serviceId:string|number, planId:string|number) =>
    ApiClient.post(`billing/services/${serviceId}/update_billing_plan`, { plan: planId }),

  issueInvoice:(serviceId:string|number) =>
    ApiClient.post(`billing/services/${serviceId}/invoice`, {}),

  deleteService:(serviceId:string|number, options?:{ delete_only_from_db?: boolean, delete_associated_resources?: boolean }) =>
    ApiClient.delete(`billing/services/${serviceId}`, { params: options }),

  enableBilling:(serviceId:string|number, newCycleStart:string) =>
    ApiClient.post(`billing/services/${serviceId}/enable_billing`, { new_cycle_start: newCycleStart }),

  hasAssociatedResource:(serviceId:string|number) =>
    ApiClient.get(`billing/services/${serviceId}/has_associated_resource`),

  changeResourceAssociation:(serviceId:string|number, projectId:string) =>
    ApiClient.post(`billing/services/${serviceId}/change_service_associated_resource`, { project_id: projectId }),

  removeResourceAssociation:(serviceId:string|number) =>
    ApiClient.post(`billing/services/${serviceId}/remove_service_associated_resource`, {}),

  // Product cycles
  getProductCycleCreateOptions:() => ApiClient.get('billing/productcycles/create_options'),
  createProductCycle:(data:any) => ApiClient.post('billing/productcycles', data),
  updateProductCycle:(cycleId:string|number, data:any) => ApiClient.put(`billing/productcycles/${cycleId}`, data),
  deleteProductCycle:(cycleId:string|number) => ApiClient.delete(`billing/productcycles/${cycleId}`),

  // Service price helper
  getServiceNewPrice:(serviceId:string|number, cycleId:string|number, overridePrice?:number|null, configurableOptions?:any[], isFree?:boolean) => {
    const params: any = { cycle_id: cycleId };
    if (overridePrice !== null && overridePrice !== undefined) params.override_price = overridePrice;
    if (configurableOptions) params.configurable_options = JSON.stringify(configurableOptions);
    if (isFree !== undefined) params.is_free = isFree;
    return ApiClient.get(`billing/services/${serviceId}/get_new_fixed_price`, { params });
  },
}

export default billingService;
